/**
 * Form validation utilities for authentication.
 * Per design guidelines: email pattern, password strength, slug generation.
 */

export const validateEmail = (email: string): boolean => {
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return pattern.test(email);
};

/**
 * Requirements: 8+ chars, uppercase, lowercase, number, special character.
 */
export const validatePassword = (password: string): boolean => {
  return (
    password.length >= 8 &&
    /[a-z]/.test(password) &&
    /[A-Z]/.test(password) &&
    /\d/.test(password) &&
    /[@$!%*?&]/.test(password)
  );
};

export const generateSlug = (name: string): string => {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

/** 0–4 strength score. */
export const calculatePasswordStrength = (password: string): number => {
  let strength = 0;
  if (password.length >= 8) strength++;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) strength++;
  if (/\d/.test(password)) strength++;
  if (/[@$!%*?&]/.test(password)) strength++;
  return strength;
};

export const getPasswordStrengthText = (strength: number): string => {
  const labels = ['Weak', 'Fair', 'Good', 'Strong'];
  return labels[strength - 1] ?? 'Too Weak';
};

export const getPasswordStrengthColor = (strength: number): string => {
  if (strength <= 1) return 'text-red-600';
  if (strength === 2) return 'text-amber-600';
  if (strength === 3) return 'text-emerald-600';
  return 'text-emerald-700';
};
